import { MessageOutlined } from "@ant-design/icons";
import { BButton } from "components/base";
import clsx from "clsx";
import { useCallback } from "react";
import "./SidebarChatsShortcut.scss";

type SidebarChatsShortcutProps = {
  onExpand: () => void;
};

const SidebarChatsShortcut = ({ onExpand }: SidebarChatsShortcutProps) => {
  const handleClick = useCallback(() => {
    onExpand();
  }, [onExpand]);

  return (
    <BButton
      type="text"
      className={clsx("sidebar-chats-shortcut", "sidebar-chats-shortcut--collapsed")}
      icon={<MessageOutlined />}
      onClick={handleClick}
      aria-label="Mở danh sách chat"
      title="Mở danh sách chat"
    />
  );
};

export default SidebarChatsShortcut;
